import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { forwardRef, useState } from 'react';
import { cn } from '../../utilities/cn';
import { Tooltip } from '@mui/material';
import { ultraTableStyles } from '../tables/ultraTable/styles/ultratable.styles';
import { HiOutlineChevronUpDown } from 'react-icons/hi2';
import SearchBar from './inputs/SearchBar';

interface GenericDropdownProps<T> {
  className?: string;
  label?: string;
  dropdownButton?: boolean;
  placeholder?: string;
  data: T[];
  getDisplayValue: (item: T) => string;
  //   getDisplayIcon?: (item: T) => any;
  selected: T[] | T;
  setSelected: (value: T[] | T) => void;
  tooltip?: string;
  dropdownClassName?: string;
  searchBar?: boolean;
}

const GenericDropdown = forwardRef<HTMLDivElement, GenericDropdownProps<any>>(
  <T,>(props: GenericDropdownProps<T>, ref: React.Ref<HTMLDivElement>) => {
    const classes = ultraTableStyles();

    const [searchValue, setSearchValue] = useState('');

    const filteredData = props.data.filter((data) =>
      props
        .getDisplayValue(data)
        .toLowerCase()
        .includes(searchValue.toLowerCase()),
    );

    return (
      <div ref={ref} className="font-sans">
        <Menu>
          <Tooltip
            classes={{ tooltip: classes.columnHeadTooltip }}
            title={props.tooltip || ''}
            placement="top"
            enterDelay={500}
          >
            <MenuButton
              className={cn(
                'inline-flex items-center gap-2 rounded-md bg-mainblue fill-white/60 px-3 py-1.5 font-sans text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-gray-700 data-[open]:bg-gray-700 data-[focus]:outline-1 data-[focus]:outline-white',
                props.className,
              )}
            >
              {props.label || 'Options'}
              <HiOutlineChevronUpDown className="h-5 w-5" />
            </MenuButton>
          </Tooltip>

          <MenuItems
            transition
            anchor="bottom end"
            className={cn(
              'z-50 origin-top-right rounded-xl border border-black/5 bg-white p-1 text-sm/6 text-black transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0',
              props.dropdownClassName,
            )}
          >
            {props.searchBar && <SearchBar searchHandler={setSearchValue} />}
            {filteredData.map((item, index) => {
              const isSelected = Array.isArray(props.selected)
                ? props.selected.includes(item)
                : props.selected === item;

              return (
                <MenuItem key={index}>
                  <button
                    onClick={() => props.setSelected(item)}
                    className={`group flex w-full items-center gap-2 rounded-lg px-3 py-1.5 data-[focus]:bg-blue-50 ${isSelected && 'bg-blue-100'
                      }`}
                  >
                    <div className="text-sm/6">
                      {props.getDisplayValue(item)}
                    </div>
                  </button>
                </MenuItem>
              );
            })}
          </MenuItems>
        </Menu>
      </div>
    );
  },
);

export default GenericDropdown;
